module.exports = __webpack_public_path__ + "img/venuetwo-zqcg.4525f18a.png";